const cookieBannerWrapperId = "cookiescript_injected_wrapper";

const applyCookieBannerAccessibility = () => {
  const wrapper = document.getElementById(cookieBannerWrapperId);
  if (!wrapper) return false;

  wrapper.setAttribute("role", "region");
  wrapper.setAttribute("aria-label", "Cookie consent banner");

  if (document.body.firstElementChild !== wrapper) {
    document.body.insertBefore(wrapper, document.body.firstElementChild);
  }

  return true;
};

export const setupCookieConsentBannerAccessibility = () => {
  if (applyCookieBannerAccessibility()) return;

  const observer = new MutationObserver(() => {
    if (applyCookieBannerAccessibility()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};
